
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/free-courses",
      function () {
        return require("private-next-pages/free-courses/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/free-courses"])
      });
    }
  